var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSideDashUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.50419 3.06752C5.22517 2.7885 4.77204 2.7885 4.49302 3.06752L0.921596 6.63895C0.642577 6.91797 0.642577 7.37109 0.921596 7.65011C1.20061 7.92913 1.65374 7.92913 1.93276 7.65011L4.99972 4.58315L8.06669 7.64788C8.3457 7.9269 8.79883 7.9269 9.07785 7.64788C9.35686 7.36886 9.35686 6.91574 9.07785 6.63672L5.50642 3.06529L5.50419 3.06752Z",
    fill: "#43BBC9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideDashUp);
export default __webpack_public_path__ + "static/media/sideDashUp.9ddb841fcb26b07f6706f38420410eb4.svg";
export { ForwardRef as ReactComponent };